<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                用户举报
               
            </div>
            
            <div >

                <!-- table组件 -->
                <div class="my_table">
                    <!-- <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    
                    </Header> -->
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                                <Button class="mR5"    type="warning"    @click='del_num = 2;route="/layout/circle/postReport/del";delFun("{}");' > <Icon type="md-close" />批量删除举报</Button>                              
                            </div>
                            
                        </Row>
                     
                    </div>
                
                
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    <Table    border  :columns="columns1" :data="data1" @on-selection-change="checkFun" ref='table'>
                    
                        <!-- 图片 -->
                            <template slot-scope="{ row }" slot="user_image">                               
                                <Avatar  size="large"     :src=" row.user_image "/>
                             
                            </template>


                            <template slot-scope="{ row }" slot="userReport_image">                               
                                <Avatar  size="large"     :src=" row.userReport_image "/>
                             
                            </template>
                        
                       
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                           
                            
                            <!-- <Poptip trigger="hover"  content="查看帖子">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/postReport/query";queryFun(row)'  type="info"      icon="md-search"></Button>
                            </Poptip> -->
                            
                            <Poptip trigger="hover"  content="删除举报">
                                <Button class="padlr5"  size="small" @click='del_num = 0;route="/layout/circle/postReport/del";delFun(row)'  type="warning"      icon="md-close"></Button>
                            </Poptip>
                            
                        
                        </template>
                        
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>
                    
                    <!-- 确认删除框 -->
                    <Modal
                        v-model="delM"
                        title="提示"
                        @on-ok="delOk"
                        @on-cancel="cancel"
                        class-name="vertical-center-modal"
                    >   
                        <p v-if="del_num ==  0">确定删除举报吗?</p>
                        <p v-if="del_num ==  1">确定删除帖子吗?</p>
                        <p v-if="del_num ==  2">确定批量删除举报吗?</p>
                        
                    </Modal>
                </div>

            </div>

       </div>

       <!-- 查看详情-->
        <Modal
            v-model="queryM"
            title = "查看详情"
            class-name="vertical-center-modal"
            okText="关闭"
            cancelText=""
            closable
            >

            <div v-if='userReport_guid'>
                <Child  :child_guid='userReport_guid'></Child>
            </div>
      
        </Modal>
       
       
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    import Child from '../../child_vue/report_child.vue';

    export default {
        name:'userReport',
        data () {
            return {
                route: null,
                token:'',
                
                del_num: 0,  //0  删除举报, 1 删除帖子  ,2 批量删除举报

                columns1:[],  
                data1:[],
                page:1,
                size: 20,
                total: 0,


                checkGuid2:'',
           
              
  
                queryM: false,        //查看弹窗
                delM: false,          //删除弹窗

                guid: null,           //本条记录 guid
                user_guid: null,      //用户     guid
                userReport_guid: null,   //被举报用户     guid
                
                checks_guid: []              //多选选中 的帖子 guid
                
            }
        },
     
        watch:{
           
          
        },

        props: ['child_guid'],
        components: {
            Child
        },

        computed: {
         
         
            
        },
        
        methods: {
           load(){
              let that = this;

              that.$myAjax.get('admin/service/admin/report/user/log?page='+that.page+'&size='+that.size).then( res => {
                    let data1;
                    that.columns1 = [
                       {type:'selection',width: 60,align:'center'},
                       {title:'举报者',key:'user_name',align:'center',minWidth: 60,maxWidth:150},
                       {title:'举报头像',slot:'user_image',align:'center',width:120},
                       {title:'被举报者',key:'userReport_name',align:'center',minWidth: 60,maxWidth:150},
                       {title:'被举报头像',slot:'userReport_image',align:'center',width:120},
                       {title:'举报类型',key:'reportType2',align:'center',width: 250},
                       {title:'举报内容',key:'content',align:'center',minWidth: 300,ellipsis: true,
                            render:(h,params)=>{
                                return h(
                                        'span',
                                            {     
                                            style:{
                            
                                            },
                                            //就是这里加的属性
                                            domProps: {
                                                title: params.row.content
                                            }
                                        },
                                        params.row.content
                                        )
                                
                            }
                       },
                       {title:'举报时间',key:'createTime',align:'center',minWidth: 125,maxWidth: 200},
                       {title:'操作',slot:'btn',align:'center',width: 120,fixed: 'right'},
                    ];
                    data1 = res.data.data.list;
                    for(let i = 0; i<data1.length;i++ ){
                        data1[i].user_image = data1[i].user.image;
                        data1[i].user_name = data1[i].user.name;
                        data1[i].user_guid = data1[i].user.guid;

                        data1[i].userReport_image = data1[i].reportUser.image;
                        data1[i].userReport_name = data1[i].reportUser.name;
                        data1[i].userReport_guid = data1[i].reportUser.guid;

                        
                        
                        
                       
                        
                    }
                    that.$split(data1);
                    that.$data_null.editor(data1);
                    that.data1 = data1;
                    
                    that.total =  res.data.data.total;

              })
              
              
              

                 

              
           },

            //    选择
            checkFun(){
                let that = this;
                let checks = [];
                let list = that.$refs.table.getSelection();
                let len = list.length;
                for(let i =  0;i<len;i++){
                    checks.push(list[i].guid)
                }
                
                that.checks_guid = checks;
               
            },
            
            //    查看
            queryFun(res){
                this.queryM = true;
                this.userReport_guid = res.userReport_guid;
              
            },
           
            // 删除
            delFun(res){
                let that = this;

                that.guid = res.guid;
               
                that.reportUser_guid = res.reportUser_guid;
                that.$canBtn( that.route).then( function(res_c){
                    that.delM = true;
                })
            },
            delOk(){
                //del_num  0  删除举报, 1 删除帖子  ,2 批量删除举报
                let that = this;
                if( that.del_num == 0 ){
                    // 删除举报
                    that.$myAjax.delete(
                        'admin/service/admin/report/article/log?guid='+that.guid+'&route='+that.route
                    ).then(res => {
                    
                        that.load();
                    })
                }else if(that.del_num == 1){
                    // 删除举报
                    that.$myAjax.delete(
                        'admin/service/admin/report/article/log?guid='+that.guid+'&route='+that.route
                    ).then(res => {
                    
                        that.load();
                    })
                    
                }else if(that.del_num == 2){
                    // 批量删除帖子
                    
                    that.$myAjax.post(
                        'admin/service/admin/report/article/log/batch?route='+that.route, 
                        that.checks_guid
                        
                        
                        
                    ).then(res => {
                    
                        that.load();
                    })
                }
               
                
            },
            
            
            // 顶部添加
            
            addFun(){
                let that = this;
                

                that.$canBtn( that.route).then( function(res_c){
                    that.modal2 = true;

                    that.model1 = null;
                    that.model2 = null;
                  
                })
            },
            ok_add(){
                let that = this;
                
                that.$ajax({
                
                    method:'post',
                    url: 'admin/service/admin/trend/type?route='+that.route,
                    data:{
                        sort: that.model1,
                        title: that.model2
                  
                    },
                    
                }).then(res => {
                    that.$alert.info(res);
                    
                    if(res.data.code != 0){
                        that.load();
                        that.cancel_add();
                    }
                    
                })
                    
                
               
            },
            cancel_add(){
            
                this.modal2 = false;
            },

            cancel(){},

            // 分页
            change_page(index){
                this.load();
            },
            change_size(size){
                this.size = size;
            },

            
         
        },
        mounted: function(){
           var that = this;
           that.vCropper = that.$store.state.vCropper;
           
           that.token = that.$store.state.token;
           
           that.load();
          
         
        }
    }
</script>
<style scoped>
     /* public 内容用  /就行 */
     @import "/css/modal.css";

    

    
</style>




